<template>
  <div :class="dynamicClasses" class="action-footer">
   <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'nna-action-footer',
  props: {
    padding: {
      type: Boolean,
      default: false
    },    
  },
  computed: {
    dynamicClasses () {
      return {
        ['p-3']: this.padding,
      }
    }
  }
}
</script>
<style scoped>
.action-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 200;
  overflow: hidden;
  background: #fff;  
}

</style>




// WEBPACK FOOTER //
// ../nonameapp-common-modules/src/components/ActionFooter/ActionFooter.vue